import { render, staticRenderFns } from "./freightAccount.vue?vue&type=template&id=41244472&scoped=true&"
import script from "./freightAccount.vue?vue&type=script&lang=js&"
export * from "./freightAccount.vue?vue&type=script&lang=js&"
import style0 from "./freightAccount.vue?vue&type=style&index=0&id=41244472&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41244472",
  null
  
)

export default component.exports